export const languagesShared = [
  "en",
  "ru",
  "es",
  "pt-br",
  "uk",
  "fa",
  "ar",
] as const;

export type LanguageShared = (typeof languagesShared)[number];

export function isLanguage(
  language?: string | null,
): language is LanguageShared {
  return languagesShared.includes(language as LanguageShared);
}

export function isRtlLanguage(language: LanguageShared) {
  return language === "ar" || language === "fa";
}

export enum LanguageCatalogItemAvailableIn {
  En = "en",
  Ru = "ru",
  Es = "es",
  Uk = "uk",
  // Arabic
  Ar = "ar",
  // Farsi
  Fa = "fa",
  PtBr = "pt-br",
}

export function languageSharedToHuman(type: LanguageShared) {
  switch (type) {
    case "en":
      return "English";
    case "ru":
      return "Русский";
    case "es":
      return "Español";
    case "pt-br":
      return "Português";
    case "ar":
      return "العربية";
    case "fa":
      return "فارسی";
    case "uk":
      return "Українська";
    default:
      return type satisfies never;
  }
}

export function languageCatalogItemAvailableInToNative(
  type: LanguageCatalogItemAvailableIn,
) {
  switch (type) {
    case LanguageCatalogItemAvailableIn.En:
      return "English";
    case LanguageCatalogItemAvailableIn.Ru:
      return "Русский";
    case LanguageCatalogItemAvailableIn.Es:
      return "Español";
    case LanguageCatalogItemAvailableIn.Uk:
      return "Українська";
    case LanguageCatalogItemAvailableIn.PtBr:
      return "Português";
    case LanguageCatalogItemAvailableIn.Ar:
      return "العربية";
    case LanguageCatalogItemAvailableIn.Fa:
      return "فارسی";
    default:
      return type satisfies never;
  }
}
